// react
import { useState } from 'react';
// @mui
import Stack from '@mui/material/Stack';
import { IconButton } from '@mui/material';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormControl from '@mui/material/FormControl';
import {
  ToolbarButton,
  ColumnsPanelTrigger,
  FilterPanelTrigger,
  Toolbar,
  ExportCsv,
} from '@mui/x-data-grid-premium';
// components
import Iconify from 'src/components/iconify';
// redux
import { useSelector } from 'src/redux/store';
// localization
import { useLocales } from 'src/locales';

type Props = {
  removeTable: () => void;
  index: number;
  disableEdit?: boolean;
  intervalModel: number[];
  onIntervalChange: (value?: number) => void;
  onDescriptionChange: (value: string) => void;
};

export function ReportTableToolbar({
  removeTable,
  index,
  disableEdit,
  intervalModel,
  onIntervalChange,
  onDescriptionChange,
}: Props) {
  const { t } = useLocales();

  const tables = useSelector((state) => state.report.report.tables);

  const [description, setDescription] = useState(tables![index]?.description ?? '');

  const renderTitle = () =>
    [tables![index]?.description ? tables![index]?.description : undefined]
      .filter((x) => x)
      .map((x, i) => (
        <Typography
          key={`${index}-${intervalModel[0] !== -1 ? intervalModel[0] : 0}-${i}-typography`}
          variant="body2"
        >
          {t(x ?? '')}
        </Typography>
      ));

  return disableEdit ? (
    <Toolbar
      key={`${index}-${intervalModel[0] !== -1 ? intervalModel[0] : 0}-toolbar`}
      style={{ marginTop: 10, marginBottom: 10, marginLeft: 10, marginRight: 10 }}
    >
      <Stack spacing={1} sx={{ flex: 1, flexDirection: 'row', alignItems: 'center' }}>
        {renderTitle()}
      </Stack>
      <Stack
        sx={{
          display: 'flex',
          justifyContent: 'right',
        }}
      >
        <ExportCsv render={<ToolbarButton render={<Button>Export</Button>} />} />
      </Stack>
    </Toolbar>
  ) : (
    <Toolbar
      key={`${index}-toolbar`}
      style={{
        position: 'relative',
        justifyContent: 'left',
        marginTop: 10,
        marginBottom: 10,
      }}
    >
      <ColumnsPanelTrigger
        render={<ToolbarButton render={<Button>{t('Columns')}</Button>} />}
        style={{}}
      />
      <FilterPanelTrigger render={<ToolbarButton render={<Button>{t('Filter')}</Button>} />} />
      <FormControl
        sx={{
          ml: 2,
          width: { xs: 200, md: 200 },
        }}
      >
        <InputLabel size="small">{t('Description')}</InputLabel>
        <OutlinedInput
          label={t('Description')}
          placeholder={t('Description')}
          size="small"
          onChange={(event) => setDescription(event.target.value)}
          onBlur={(event) => onDescriptionChange(event.target.value)}
          value={description}
        />
      </FormControl>
      {tables!.length > 1 && (
        <IconButton onClick={removeTable} sx={{ position: 'absolute', right: 25 }}>
          <Iconify icon="solar:trash-bin-trash-bold" />
        </IconButton>
      )}
    </Toolbar>
  );
}
